// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function TableCell(theme) {
  return {
    MuiTableCell: {
      styleOverrides: {
        root: ({ ownerState }) => {
          const baseStyle = {
            fontSize: '0.95rem',
            padding: '12px 14px',
            borderBottom: `1px solid ${theme.vars.palette.divider}`,
            color: theme.vars.palette.text.primary,
            '&:first-of-type': {
              paddingLeft: 20
            },
            '&:last-of-type': {
              paddingRight: 20
            }
          };

          if (ownerState.align === 'right') {
            return {
              ...baseStyle,
              textAlign: 'right'
            };
          }

          if (ownerState.align === 'center') {
            return {
              ...baseStyle,
              textAlign: 'center'
            };
          }

          return baseStyle;
        },
        sizeSmall: { padding: '8px 10px' },
        head: {
          backgroundColor: theme.vars.palette.grey[50],
          color: theme.vars.palette.text.secondary,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.04em'
        },
        footer: {
          backgroundColor: theme.vars.palette.grey[50]
        }
      }
    }
  };
}
